import { Component, h, Prop } from '@stencil/core';
import { applyOptions } from '../../../utils';
import { ValueOfIconUIType } from '../icon/icon-ui-type';

@Component({
    tag: 'web-link',
    styleUrl: 'link.scss',
    shadow: false
})
export class Link {
    @Prop() url: string;
    @Prop() rel: string;
    @Prop() linkTitle: string;
    @Prop() linkText: string;
    @Prop() type: '' | 'primary' | 'secondary' = '';
    @Prop() iconStart: ValueOfIconUIType;
    @Prop() iconEnd: ValueOfIconUIType;
    @Prop() fullWidth: boolean;
    @Prop() disabled: boolean;
    @Prop() openInNewWindow: boolean;

    @Prop() options: object | string;

    private classNames = {};

    componentWillLoad() {
        applyOptions(this);
        this.classNames = {
            link: true,
            'link-primary': this.type === 'primary',
            'link-secondary': this.type === 'secondary',
            'link-full-width': this.fullWidth,
            'link-disabled': this.disabled
        };
    }

    render() {
        return (
            <a
                class={this.classNames}
                href={this.url}
                title={this.linkTitle}
                aria-label={this.linkTitle}
                rel={this.rel}
                target={this.openInNewWindow ? '_blank' : '_self'}
            >
                {this.iconStart && <web-icon class="icon-start" name={this.iconStart}></web-icon>}
                {this.linkText ? <span class="link-text">{this.linkText}</span> : <slot></slot>}
                {this.iconEnd && <web-icon class="icon-start" name={this.iconEnd}></web-icon>}
            </a>
        );
    }
}
